import React from 'react';
import "../assets/Styles/DarkEffect.css";

const DarkEffect = (props) => {
    return (
        <div className='DarkEffect' ></div >
    )
}

export default DarkEffect;